import tenantsQuery from "./graphql/tenants_query.graphql";
import tenantDevicesQuery from "./graphql/tenant_devices.graphql";
import tenantCreate from "./graphql/tenant_create.graphql";
import tenantInviteUser from "./graphql/tenant_invite_user.graphql";
import tenantUpdateUser from "./graphql/tenant_update_user.graphql";
import tenantRemoveUser from "./graphql/tenant_remove_user.graphql";
import tenantRemoveUserFromTenant from "./graphql/tenant_remove_from_user.graphql";
import { runQuery } from "@/api/query";

export const queryTenants = async (nextPageToken = null, take = 50) => {
  const result = await runQuery(tenantsQuery, { nextPageToken, take });
  const tenants = result ? result.tenants.edges.map((edge) => edge.node) : [];
  const hasNextPage = result ? result.tenants.pageInfo.hasNextPage : false;
  const newNextPageToken = result ? result.tenants.pageInfo.endCursor : null;
  return { tenants, hasNextPage, nextPageToken: newNextPageToken };
};

export const queryTenantDevices = async (nextPageToken = null, tenantId) => {
  const result = await runQuery(tenantDevicesQuery, { nextPageToken, filter: { tenantIds: [tenantId] } });

  const tmpResult = result ? result.tenants.edges.map((edge) => edge.node.devices) : [];
  const tenantDevices = result ? tmpResult.map((edge) => edge.edges) : [];
  const hasNextPage = tmpResult.length > 0 ? tmpResult[0].pageInfo.hasNextPage : false;
  const newNextPageToken = tmpResult.length > 0 ? tmpResult[0].pageInfo.endCursor : null;

  return { tenantDevices, hasNextPage, nextPageToken: newNextPageToken };
};

export const createTenant = async (tenantName) => {
  return await runQuery(tenantCreate, { name: tenantName });
};

export const inviteUser = async (data) => {
  return await runQuery(tenantInviteUser, {
    ...data,
  });
};

export const updateUser = async (data) => {
  return await runQuery(tenantUpdateUser, {
    ...data,
  });
};

export const removeUser = async (data) => {
  return await runQuery(tenantRemoveUser, {
    ...data,
  });
};

export const removeUserTenant = async (data) => {
  return await runQuery(tenantRemoveUserFromTenant, {
    ...data,
  });
};
